// SAA-112 — narrowed from `Partial<Application | Questionnaire>`: this reads only two fields, and
// the wider signature is what made the union fragile (adding an unrelated field to either
// interface could tip a homomorphic-mapped-type-over-a-union edge case at an unrelated call site —
// `AdminQuestionnaireForm.tsx` passing a bare `Partner`). Every existing caller still satisfies
// this narrower shape.
export const getName = (data: { firstName?: string; lastName?: string }) => {
  return `${data?.firstName || ''} ${data?.lastName || ''}`.trim();
};
